import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupIdStopImportInProgressCacheKeys: AllRouteEndpoints[] = [
  "/apps/:app_group_id/user_imports_datatable",
];
